// Batch 5: returnable equipment asked for on one day beyond what the
// business owns — a warning on the booking form, the booking and the plan.
// Never blocks a save. Words: lib/inventoryFlow/equipmentLogic.ts.
import { AlertTriangle } from 'lucide-react'
import { EQ } from '@/lib/inventoryFlow/equipmentStrings'
import { clashLine, clashRefs } from '@/lib/inventoryFlow/equipmentLogic'
import type { EquipmentClash } from '@/lib/inventoryFlow/planTypes'

export function EquipmentClashNotice({ clashes }: { clashes?: EquipmentClash[] | null }) {
  if (!clashes?.length) return null
  return (
    <div role="status" className="space-y-1.5 rounded-lg border border-amber-400 bg-amber-50 p-3 text-sm text-amber-900 dark:bg-amber-950/40 dark:text-amber-100">
      <p className="flex items-center gap-1.5 font-semibold"><AlertTriangle className="h-4 w-4 shrink-0" aria-hidden /> {EQ.clashTitle}</p>
      <ul className="space-y-1">
        {clashes.map((c) => (
          <li key={c.stock_item_id}>
            <span className="font-medium">{clashLine(c)}</span>
            {clashRefs(c) && <span className="block text-xs">{clashRefs(c)}</span>}
          </li>
        ))}
      </ul>
      <p className="text-xs">{EQ.clashHelp}</p>
    </div>
  )
}
